/* eslint-disable import/prefer-default-export */
export const documentTypes = [
  {
    title: 'Contract',
    key: 'contract',
  },
  {
    title: 'Company Profile',
    key: 'company_profile',
  },
  {
    title: 'Company Resolution',
    key: 'company_resolution',
  },
  {
    title: 'Certification of Incorporation',
    key: 'certificate_of_incorporation',
  },
  {
    title: 'Trading License',
    key: 'trading_license',
  },
  {
    title: 'Proof of Address',
    key: 'proof_of_address',
  },
  {
    title: 'Share Structure',
    key: 'share_structure',
  },
];
